import type React from 'react';

import { Redirect, useKnownAvailableParams } from '@change-corgi/core/react/router';

import type { LandingPageSlug } from 'src/app/pages/landing/template/shared/types';

import { RenderTemplate } from '../components/RenderTemplate';

function isValidSlug(incomingSlug: string): incomingSlug is LandingPageSlug {
	return [
		'start-a-healthcare-reform-petition',
		'how-to-start-a-petition',
		'start-a-local-municipal-reform-petition',
		'start-a-local-school-reform-petition',
		'start-an-education-reform-petition',
		'cambiemoscolombia',
	].includes(incomingSlug);
}

export const TemplateContainer: React.FC = () => {
	const { slug } = useKnownAvailableParams<{ slug: LandingPageSlug }>();
	if (!isValidSlug(slug)) {
		return <Redirect to="/lp/how-to-start-a-petition" />;
	}
	return <RenderTemplate slug={slug} />;
};
